import { useDisclosure } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import SidebarMenuList from 'presentation/components/shared/sidebar/menu/SidebarMenuList';
import SidebarLayout from 'presentation/layout/shared/SidebarLayout';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import LogoutConfirmModal from 'presentation/containers/modules/auth/LogoutConfirmModal';

import profileIcon from 'assets/img/icons/settings/profile.png';
import accountsIcon from 'assets/img/icons/settings/accounts.png';
import documentsIcon from 'assets/img/icons/settings/documents.png';
import notificationsIcon from 'assets/img/icons/settings/notifications.png';
import ipoApplicationsIcon from 'assets/img/icons/settings/ipo-applications.png';
import telegramIcon from 'assets/img/icons/settings/telegram.png';
import logoutIcon from 'assets/img/icons/settings/logout.png';
import PersonalManagerChatCard from 'presentation/containers/modules/chat/detail/PersonalManagerChatCard';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';

const SettingsSidebar: FC = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const location = useLocation();

  const {
    isOpen: isLogoutConfirmModalOpen,
    onOpen: onLogoutConfirmModalOpen,
    onClose: onLogoutConfirmModalClose,
  } = useDisclosure();

  return (
    <SidebarLayout>
      <AppCard display="flex" flexDir="column" w="100%">
        <SidebarMenuList
          items={[
            {
              onClick: () => {
                navigate(AppRoute.profile);
              },
              text: t('profileLabel'),
              icon: profileIcon,
              iconSize: '38px',
              isActive: location.pathname === AppRoute.profile,
            },
            {
              onClick: () => {
                navigate(AppRoute.brokerList);
              },
              text: t('navAccounts'),
              icon: accountsIcon,
              iconSize: '38px',
              isActive: location.pathname.startsWith(AppRoute.brokerList),
            },
            {
              onClick: () => {
                navigate(AppRoute.myDocumentsPath);
              },
              text: t('myDocuments'),
              icon: documentsIcon,
              iconSize: '38px',
              isActive: location.pathname.startsWith(AppRoute.myDocumentsPath),
            },
            {
              onClick: () => {
                navigate(AppRoute.notifications);
              },
              text: t('notifications'),
              icon: notificationsIcon,
              iconSize: '38px',
              isActive: location.pathname.startsWith(AppRoute.notifications),
            },
            {
              onClick: () => {
                navigate(AppRoute.selfIpoApplications);
              },
              text: t('selfIpoApplicationsProfileButton'),
              icon: ipoApplicationsIcon,
              iconSize: '38px',
              isActive: location.pathname.startsWith(
                AppRoute.selfIpoApplications
              ),
            },
            {
              onClick: () => {
                navigate(AppRoute.telegramPath);
              },
              text: 'Telegram',
              icon: telegramIcon,
              iconSize: '38px',
              isActive: location.pathname.startsWith(AppRoute.telegramPath),
            },
            {
              onClick: onLogoutConfirmModalOpen,
              text: t('logout'),
              icon: logoutIcon,
              iconSize: '38px',
              isActive: false,
            },
          ]}
        />
      </AppCard>
      <PersonalManagerChatCard
        mt="20px"
        roomType={ChatRoomType.PersonalManager}
      />
      <LogoutConfirmModal
        isOpen={isLogoutConfirmModalOpen}
        onClose={onLogoutConfirmModalClose}
      />
    </SidebarLayout>
  );
};

export default SettingsSidebar;
